import { useQuery } from '@tanstack/react-query';
import { memoTagKeys } from '../api/memoTagAPI';
import { fetchMemoTag, fetchAllMemoTags } from '../api/memoTagAPI';
import { UIMemoTag } from '../../model/UiShapes';

/**
 * Memo Tag查询hooks - 统一命名规范
 */

// 获取单个memo的标签数据
export const useMemoTagQuery = (memoId: string, options?: { enabled?: boolean }) => {
  const queryResult = useQuery({
    queryKey: memoTagKeys.detail(memoId),
    queryFn: async () => {
      try {
        // 调用API获取memo标签
        const memoTag = await fetchMemoTag(memoId);
        
        // 如果未找到标签，返回空的标签对象
        if (!memoTag) {
          return {
            memoId: memoId,
            tags: []
          } as UIMemoTag;
        }
        
        return memoTag;
      } catch (error) {
        throw error;
      }
    },
    enabled: options?.enabled !== undefined ? options.enabled : !!memoId,
    staleTime: 5 * 60 * 1000,
  });

  return queryResult;
};

// 获取所有memo的标签数据
export const useAllMemoTagsQuery = (options?: { enabled?: boolean }) => {
  const queryResult = useQuery({
    queryKey: memoTagKeys.all,
    queryFn: async () => {
      try {
        // 调用API获取所有memo标签
        const allMemoTags = await fetchAllMemoTags();
        return allMemoTags;
      } catch (error) {
        throw error;
      }
    },
    enabled: options?.enabled !== undefined ? options.enabled : true,
    staleTime: 5 * 60 * 1000,
  });

  return queryResult;
};